import classNames from 'classnames';
import { HeadingS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React from 'react';
import { SingleDepartment } from 'utils/api/models/departments/singleDepartment';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/topupStyle';
import { makeStyles } from '@material-ui/styles';

// @ts-ignore
const useStyles = makeStyles(styles);

interface INoDepartmentsProps {
	departmentsFetched: { [key: string]: SingleDepartment };
}

const NoDepartments = ({ departmentsFetched }: INoDepartmentsProps) => {
	const classes = useStyles();

	return (
		<div className={classNames(classes.center, classes.noDepartments)}>
			<HeadingS>
				{Object.values(departmentsFetched).length === 0
					? translate('payments.topup.noDepartments')
					: translate('payments.topup.noNumbersInDepartment')}
			</HeadingS>
		</div>
	);
};

export default NoDepartments;
